<template>
  <v-flex xs12>
    <h5>Sumup Details</h5>
    <v-layout row v-if="sumupTransaction">
      <v-flex class="py-0 px-0">
        <v-list
          class="py-0 px-0"
          dense
        >
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary mr-2">{{ formatDate(sumupTransaction.timestamp) }}</span> <v-chip
                  x-small
                  color="green lighten-4"
                >
                  {{ sumupTransaction.status.toLowerCase() }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Paid By</span> Sumup
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Transaction Code</span> {{ sumupTransaction.transaction_code }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Amount</span> £{{ sumupTransaction.amount }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
      <v-flex
        v-if="sumupTransaction != null"
        xs12
        md12
        lg12
        xl12
      >
        <h4
          v-if="sumupTransaction.error != 'no_error'"
          style="color: red;"
        >
          {{ sumupTransaction.error }}
        </h4>
        <v-btn
          small
          class="text-none"
          target="_blank"
          href="https://me.sumup.com/en-us/sales/transactions"
        >
          Go to Sumup
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import moment from "moment";

export default {
  name: "SumupTransaction",
  components: {},
  props: {
    bookingForm: Object
  },
  computed: {
    sumupTransaction: function() {
      if (this.bookingForm == null) {
        return null;
      }
      return this.bookingForm.booking.sumup_transaction;
    }
  },
  mounted: function() {
    console.log("SumupTransaction");
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:MM")
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.list-item-height {
  min-height: 20px !important;
  line-height: 20px;
  font-size: 11px !important;
  font-weight: 300;
}
.v-list--dense .v-list-item .v-list-item__content, .v-list-item--dense .v-list-item__content {
  padding: 0px;
  font-size: 11px;
}

.v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 11px !important;
  font-weight: 450;
}



</style>
